import { takeLatest } from 'redux-saga/effects';
import {
  getChatListSuccess, getChatListFail,
  getChatDetailsSuccess, getChatDetailsFail,
  getChatMembersSuccess, getChatMembersFail,
  getChatMessagesSuccess, getChatMessagesFail,
} from './chatState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/chat-conversations');
const redirectData = {route:'/console/chats', mode: 'list', recordId:0 };
const modelName = 'Chat';
const modelId = 'ccv_id';

const chatService = createCrudService('api/v1/console/chat');

function* getChatList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getChatListSuccess, 
		getChatListFail, null, null, LOADING_MSG);
}

function* getChatDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getChatDetailsSuccess, 
		getChatDetailsFail, null, null, LOADING_MSG);		
}

function* doChatCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getChatDetailsSuccess, 
		getChatDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);
}

function* doChatUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getChatDetailsSuccess, 
		getChatDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doChatDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getChatDetailsSuccess, 
		getChatDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* getChatMembers(data) {
	yield doCrudCall(
		() => chatService.getDetails(data.payload), 
		getChatMembersSuccess, 
		getChatMembersFail, null, null, LOADING_MSG);		
}

function* getChatMessages(data) {
	yield doCrudCall(
		() => chatService.getDetails(data.payload), 
		getChatMessagesSuccess, 
		getChatMessagesFail, null, null, LOADING_MSG);		
}


    
function* chatSaga() {
  yield takeLatest('chat/getChatList', getChatList);
  yield takeLatest('chat/getChatDetails', getChatDetails);
  yield takeLatest('chat/doChatCreate', doChatCreate);
  yield takeLatest('chat/doChatUpdate', doChatUpdate);
  yield takeLatest('chat/doChatDelete', doChatDelete); 
  yield takeLatest('chat/getChatMembers', getChatMembers); 
  yield takeLatest('chat/getChatMessages', getChatMessages);  
}

export default chatSaga;
